module.exports = __webpack_public_path__ + "media/illustrations/anuncio-completar-76a39764.svg";